import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">平台特色</h2>
          <p className="mt-2 text-sm text-foreground-500">为什么选择51大赛</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {featureItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl p-5 border border-background-200/70 text-center group hover:border-primary-200 transition-all duration-200 cursor-default"
            >
              <div className="w-12 h-12 mx-auto rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-500 transition-colors duration-200">
                <i className={`${item.icon} text-xl text-accent-600 group-hover:text-background-50 transition-colors duration-200`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}